<div style="z-index: 1000000" *ngIf="show" @state class="snackbar-wrap" [ngClass]="[type]">
    <p class="snackbar-text">{{ message }}</p>
</div>
